import * as React from 'react';
import {CONST, getQueryStringParams, SearchInput, SearchSelect} from "../../common";
import { QuestionnaireRoles } from '../../quiz/questionnaire/Data';

interface IState {
  form: {
    like: {
      search: string,
    },
    equal: {
      competence_id: number,
      role_id: number,
      age_group_id: number,
      sport_id: number,
      status: number
    }
  },
 }

export default class Filters extends React.Component<any, IState> {
  state: IState;

  UNSAFE_componentWillMount() {
    let old_data: any = getQueryStringParams("form");
    old_data = JSON.parse(old_data);
    this.setState({form:  {
        like: {
          search: old_data ? old_data.like.search : '',
        },
        equal: {
          competence_id: old_data ? old_data.equal.competence_id : '',
          role_id: old_data ? old_data.equal.role_id : '',
          age_group_id: old_data ? old_data.equal.age_group_id : '',
          sport_id: old_data ? old_data.equal.sport_id : '',
          status: old_data ? old_data.equal.status : '',
        }
      }})
  }

  handleInputForm = (e: React.ChangeEvent<HTMLInputElement>) => {
    let name = e.target.name.split(".");
    let newAccess: any = Object.assign({}, this.state.form);
    newAccess[name[1]][name[2]] = e.target.value;
    this.setState({form: newAccess},() =>  this.props.getResults(this.state.form));
  }

  render(){
    const {competence, age_groups, sports} = this.props;
    return (
      <div className="row align-items-center">
        <SearchInput name={'form.like.search'} value={this.state.form.like.search} onChange={this.handleInputForm} placeholder={'Search Concepts..'} />
        <SearchSelect name={'form.equal.competence_id'} value={this.state.form.equal.competence_id}  onChange={this.handleInputForm} options={[{"label": "Select Competence", "value": ""}, ...competence]}/>
        <SearchSelect name={'form.equal.age_group_id'} value={this.state.form.equal.age_group_id}  onChange={this.handleInputForm} options={[{"label": "Select Age Group", "value": ""}, ...age_groups]}/>
        <SearchSelect name={'form.equal.sport_id'} value={this.state.form.equal.sport_id}  onChange={this.handleInputForm} options={sports}/>
        <SearchSelect name={'form.equal.status'} value={this.state.form.equal.status}  onChange={this.handleInputForm} options={CONST.status}/>
        <SearchSelect name={'form.equal.role_id'} value={this.state.form.equal.role_id}  onChange={this.handleInputForm} options={[{"label": "Select Role", "value": ""}, ...QuestionnaireRoles]}/>
      </div>
    )
  }
}